var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPushIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 48,
    viewBox: "0 0 41 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1061 10.7988V36.3008H30.6392V17.5869L22.2361 27.5572L11.8907 17.3602V35.495H9.42383V11.4283L22.0701 23.8932L33.1061 10.7988Z",
    fill: "#8CC9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0488281 0.976562L38.5326 41.2643V9.10726H40.9995V47.4538L2.51574 7.16602V35.4958H0.0488281V0.976562Z",
    fill: "#8CC9E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9507 47.4303H0V38.8691H36.0168L40.9507 47.4303Z",
    fill: "#8CC9E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70312 39.7285H2.67266L5.7339 44.7397V39.7285H6.51366V45.9146H5.59363L2.487 40.9076V45.9146H1.70312V39.7285Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8875 39.7285H12.3061V40.4865H8.68788V42.3647H12.0338V43.0805H8.68788V45.1777H12.368V45.9146H7.8875V39.7285Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8551 39.7285V40.4655H15.8129V45.9146H14.9795V40.4655H12.9373V39.7285H17.8551Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5895 39.7285H19.7653L21.5063 44.9587L23.235 39.7285H24.3984V45.9146H23.6187V42.2636C23.6187 42.1373 23.6214 41.9281 23.6269 41.6361C23.6324 41.3442 23.6352 41.0311 23.6352 40.6971L21.9065 45.9146H21.0938L19.3527 40.6971V40.8866C19.3527 41.0382 19.3555 41.2698 19.361 41.5814C19.3692 41.8902 19.3734 42.1176 19.3734 42.2636V45.9146H18.5895V39.7285Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7269 39.7285H30.1455V40.4865H26.5273V42.3647H29.8732V43.0805H26.5273V45.1777H30.2074V45.9146H25.7269V39.7285Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushIcon);
export default __webpack_public_path__ + "static/media/pushIcon.049a93e50a3331af434fb10cc6a2527b.svg";
export { ForwardRef as ReactComponent };